import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { OutboundTable } from '@components/Numbers/Details/Table';
import { Page500 } from '@containers/ErrorPages/Page500';
import { numberApi } from '@reducers/number/number';

export const OutboundRatesTab = ({ did }) => {
  const numberDetails = numberApi.useGetDetailsQuery({ did });
  const {
    data: result,
    isLoading,
    status,
  } = numberApi.useGetOutboundRatesQuery({ did });
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (status === 'rejected') {
    return <Page500 />;
  }

  if (
    numberDetails.data.outbound?.lt?.active === false &&
    numberDetails.data.outbound?.lt?.can_be_upgraded === false
  ) {
    return (
      <Row>
        <Col>{numberDetails.data.outbound?.error_message}</Col>
      </Row>
    );
  }
  if (
    numberDetails.data.outbound?.lt?.active === true &&
    numberDetails.data.outbound?.pstn?.active === false &&
    numberDetails.data.outbound?.pstn?.can_be_upgraded === true
  ) {
    return (
      <>
        <Row>
          <Col>
            <OutboundTable data={result} />
          </Col>
        </Row>
        <Row>
          <Col>
            <div>{numberDetails.data.outbound?.error_message}</div>
            <Button
              variant="didxl"
              as={Link}
              to="/order/pstn-upgrade"
              size="sm"
            >
              Upgrade
            </Button>
          </Col>
        </Row>
      </>
    );
  }
  return (
    <Row>
      <Col>
        <OutboundTable data={result} />
      </Col>
    </Row>
  );
};
